<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="activatingPopUp = false"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Sub-Menu</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="listMenu.filter(v => v.url !== parent.url )"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="menu"
          label="name"
          v-model="formData"
          placeholder="Pilih Menu Lokal"
        />
        <span class="text-danger text-sm">{{ errors.first("menu") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Urutan</strong></h6>
          <span class="text-warning">(Option)</span>
        </section>
        <vs-input
          type= "number"
          name="urutan"
          class="w-full sidebar-input"
          v-model="urutan"
          placeholder="Isi nomor urutan"
        />
        <span class="text-danger text-sm">{{ errors.first("urutan") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button
          color="danger"
          class="mr-2 rounded-2xl"
          @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          :disabled="!validateForm"
          color="success"
          class="ml-2 rounded-2xl"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import listMenu from "@/layouts/components/vertical-nav-menu/navMenuItems.js";

export default {
  props: {
    parent : { type: Object, default: null },
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      listMenu,
      urutan: null,
      formData: null,
    };
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData = {
          name: this.passData.name,
          icon: this.passData.icon,
          url: this.passData.url,
        };
      } else {
        this.parentData = null;
        this.formData = null;
      }
    },
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Sub-Menu" : "Tambah Sub-Menu";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return !this.errors.any() && this.formData !== null;
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  methods: {
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if(this.urutan === null){
        this.urutan = 1
      }
      this.$store
        .dispatch("menus/cudSubMenus", [
          Object.assign(
            Object.assign(this.formData, { urutan: `${this.urutan}`, menu_id: this.parent.id }, id)
          ),
        ])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Menu Sukses!"
                : "Tambah Menu Sukses!",
            text:
              this.passData !== null
                ? `Menu ${v.name} Berhasil diedit`
                : `Menu ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          this.formData = null;
          this.urutan = null;
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          } else {
            console.error(e);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: "Terjadi kesalahan, silahkan periksa jaringan anda",
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
  },
};
</script>
